import FormattedMessage from 'I18n/components/FormattedMessage';
import { TransitionalIcon } from 'foundations-assets/icons/DynamicIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { useMemo } from 'react';
import SensitiveScopeGroupWarningIcon from '../../components/SensitiveScopeGroupWarningIcon';
import { ScopeCategoryIcon } from '../../constants/ScopeCategoryIcon';
import { getIcon } from '../../utils/icons';
import { isHighlySensitiveScope, isSensitiveScope } from '../../utils/isSensitiveScope';
import { SCOPE_GROUP_TOP_LEVEL_GROUPINGS } from '../constants/scopeGroupTopLevelGroupings';
import createScopesAuthorizationTree from '../utils/createScopesAuthorizationTree';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ScopeCategoryHeader = ({
  iconName,
  children,
  marginStyle
}) => /*#__PURE__*/_jsxs(Flex, Object.assign({}, marginStyle, {
  alignItems: "start",
  children: [/*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineEnd: "300",
    marginInlineStart: "100",
    children: /*#__PURE__*/_jsx(TransitionalIcon, {
      name: iconName,
      size: "500",
      color: "icon-core-subtle",
      alignWithText: true
    })
  }), /*#__PURE__*/_jsx(Text, {
    as: "h5",
    children: children
  })]
}));
const SensitiveScopeWarningMaybe = ({
  scopeName
}) => {
  if (isSensitiveScope(scopeName)) {
    return /*#__PURE__*/_jsx(SensitiveScopeGroupWarningIcon, {
      paddingInlineEnd: "100",
      highlySensitive: isHighlySensitiveScope(scopeName)
    });
  }
  return null;
};
const ScopesAuthorization = ({
  scopes
}) => {
  const scopesAuthorizationTree = useMemo(() => createScopesAuthorizationTree(scopes), [scopes]);
  const hasOtherCategory = Object.keys(scopesAuthorizationTree).includes(SCOPE_GROUP_TOP_LEVEL_GROUPINGS.other);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [Object.entries(scopesAuthorizationTree).map(([category, scopeGroups]) => {
      // Display other category last with legacy UI
      if (category === SCOPE_GROUP_TOP_LEVEL_GROUPINGS.other) {
        return null;
      }
      return /*#__PURE__*/_jsx(AccordionItem, {
        title: /*#__PURE__*/_jsx(ScopeCategoryHeader, {
          iconName: ScopeCategoryIcon[category],
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-experience-shared-components.scopesAuthorization.headings.${category}`
          })
        }),
        defaultOpen: true,
        marginBlock: "400",
        children: /*#__PURE__*/_jsx("div", {
          children: scopeGroups.map((relatedScopeGroups, i) => {
            return /*#__PURE__*/_jsx(List, {
              marginBlockEnd: "400",
              children: relatedScopeGroups.map(scopeGroup => {
                return /*#__PURE__*/_jsxs(ListItem, {
                  paddingInlineStart: "900",
                  "data-test-id": `authorize-scope-${scopeGroup.name}`,
                  children: [/*#__PURE__*/_jsx(SensitiveScopeWarningMaybe, {
                    scopeName: scopeGroup.name
                  }), scopeGroup.translatedDescription]
                }, scopeGroup.id);
              })
            }, `${category}-${i}`);
          })
        })
      }, category);
    }), hasOtherCategory && scopesAuthorizationTree[SCOPE_GROUP_TOP_LEVEL_GROUPINGS.other].flat().map(scope => {
      return /*#__PURE__*/_jsxs("div", {
        "data-test-id": `authorize-scope-${scope.name}`,
        children: [/*#__PURE__*/_jsx(ScopeCategoryHeader, {
          iconName: scope.pictoIcon ? getIcon(scope.pictoIcon) : 'circleFilled',
          marginStyle: {
            marginBlockStart: '400'
          },
          children: scope.translatedLabel
        }), /*#__PURE__*/_jsxs(View, {
          paddingInlineStart: "900",
          as: "div",
          children: [/*#__PURE__*/_jsx(SensitiveScopeWarningMaybe, {
            scopeName: scope.name
          }), scope.translatedDescription]
        })]
      }, scope.id);
    })]
  });
};
export default ScopesAuthorization;